<template>
  <v-container class="pa-4">
    <v-skeleton-loader
      v-if="load"
      class="mx-auto"
      type="list-item-three-line, card-heading, image, actions"
    />
    
    <v-form
      v-if="!load"
      v-model="valid"
      lazy-validation
    >
      <!-- Section 1: Queixas -->
      <v-row class="mb-2">
        <v-col
          cols="12"
          class="py-0"
        >
          <h3 class="text-h6 text-primary font-weight-medium">
            Queixas
          </h3>
        </v-col>
        <v-col
          cols="12"
          class="pt-0"
        >
          <v-textarea
            v-model="form.queixas"
            variant="outlined"
            name="queixas"
            label="Queixas"
            rows="2"
            row-height="20"
            density="compact"
            hide-details
          />
        </v-col>
      </v-row>
      <v-divider class="my-3" />

      <!-- Section 2: Histórico Laboral -->
      <v-row class="mb-2">
        <v-col
          cols="12"
          class="py-0"
        >
          <h3 class="text-h6 text-primary font-weight-medium">
            Histórico Laboral
          </h3>
        </v-col>
        <v-col
          cols="12"
          class="pt-0"
        >
          <v-textarea
            v-model="form.historicoLaboral"
            variant="outlined"
            name="historicoLaboral"
            label="Histórico Laboral"
            rows="2"
            row-height="20"
            density="compact"
            hide-details
          />
        </v-col>
      </v-row>
      <v-divider class="my-3" />

      <!-- Section 3: Acidente de Trabalho -->
      <v-row class="mb-2">
        <v-col
          cols="12"
          class="py-0"
        >
          <h3 class="text-h6 text-primary font-weight-medium">
            Já sofreu acidente de trabalho?
          </h3>
        </v-col>
        <v-col
          cols="12"
          class="pt-0"
        >
          <v-radio-group
            v-model="form.sofreuAcidente"
            inline
            hide-details
            density="compact"
          >
            <v-radio
              label="Sim"
              value="Sim"
              color="primary"
            />
            <v-radio
              label="Não"
              value="Não"
              color="primary"
            />
          </v-radio-group>
        </v-col>

        <template v-if="form.sofreuAcidente === 'Sim'">
          <v-col
            cols="6"
            class="pt-0"
          >
            <v-checkbox
              v-model="form.acidenteAfastamento"
              label="Com afastamento"
              color="primary"
              density="compact"
              hide-details
            />
            <v-checkbox
              v-model="form.acidenteSequelas"
              label="Com sequela"
              color="primary"
              density="compact"
              hide-details
            />
          </v-col>
          <v-col
            cols="6"
            class="pt-0"
          >
            <v-checkbox
              v-model="form.acidenteSemAfastamento"
              label="Sem afastamento"
              color="primary"
              density="compact"
              hide-details
            />
            <v-checkbox
              v-model="form.acidenteSemSequelas"
              label="Sem sequela"
              color="primary"
              density="compact"
              hide-details
            />
          </v-col>
          <v-col
            cols="12"
            class="pt-0"
          >
            <v-textarea
              v-model="form.obsAcidente"
              variant="outlined"
              name="obsAcidente"
              label="Observação sobre o acidente"
              rows="2"
              row-height="20"
              density="compact"
              hide-details
            />
          </v-col>
        </template>
      </v-row>
      <v-divider class="my-3" />

      <!-- Section 4: Afastamento INSS -->
      <v-row class="mb-2">
        <v-col
          cols="12"
          class="py-0"
        >
          <h3 class="text-h6 text-primary font-weight-medium">
            Afastamento INSS
          </h3>
        </v-col>
        <v-col
          cols="12"
          class="pt-0"
        >
          <v-textarea
            v-model="form.afastamentoInss"
            variant="outlined"
            name="afastamentoInss"
            label="Informações sobre afastamento INSS"
            rows="2"
            row-height="20"
            density="compact"
            hide-details
          />
        </v-col>
      </v-row>
      <v-divider class="my-3" />

      <!-- Section 5: Antecedentes Pessoais -->
      <v-row class="mb-2">
        <v-col
          cols="12"
          class="py-0"
        >
          <h3 class="text-h6 text-primary font-weight-medium">
            Antecedentes Pessoais
          </h3>
        </v-col>
        <v-col
          cols="6"
          class="pt-0"
        >
          <v-checkbox
            v-model="form.antecedentesComorbidades"
            label="Comorbidades"
            color="primary"
            density="compact"
            hide-details
          />
          <v-checkbox
            v-model="form.antecedentesCirurgias"
            label="Cirurgias prévias"
            color="primary"
            density="compact"
            hide-details
          />
        </v-col>
        <v-col
          cols="6"
          class="pt-0"
        >
          <v-checkbox
            v-model="form.antecedentesAcidentes"
            label="Acidentes prévios"
            color="primary"
            density="compact"
            hide-details
          />
        </v-col>
        <v-col
          cols="12"
          class="pt-0"
        >
          <v-textarea
            v-model="form.obsAntecedentes"
            variant="outlined"
            name="obsAntecedentes"
            label="Observação sobre antecedentes"
            rows="2"
            row-height="20"
            density="compact"
            hide-details
          />
        </v-col>
      </v-row>
      <v-divider class="my-3" />

      <!-- Section 6: Estilo de Vida -->
      <v-row class="mb-2">
        <v-col
          cols="12"
          class="py-0"
        >
          <h3 class="text-h6 text-primary font-weight-medium">
            Estilo de Vida
          </h3>
        </v-col>
        <v-col
          cols="12"
          class="pt-0"
        >
          <div class="d-flex flex-column ga-2">
            <div class="d-flex align-center">
              <v-checkbox
                v-model="form.estiloFuma"
                label="Fumante"
                color="primary"
                density="compact"
                hide-details
                class="mr-4"
              />
              <v-text-field
                v-model="form.obsEstiloFuma"
                variant="outlined"
                label="Observação sobre tabagismo"
                :disabled="!form.estiloFuma"
                density="compact"
                hide-details
                class="flex-grow-1"
              />
            </div>
            
            <div class="d-flex align-center">
              <v-checkbox
                v-model="form.estiloBebe"
                label="Consome álcool"
                color="primary"
                density="compact"
                hide-details
                class="mr-4"
              />
              <v-text-field
                v-model="form.obsEstiloBebe"
                variant="outlined"
                label="Observação sobre consumo de álcool"
                :disabled="!form.estiloBebe"
                density="compact"
                hide-details
                class="flex-grow-1"
              />
            </div>
            
            <div class="d-flex align-center">
              <v-checkbox
                v-model="form.estiloAtividadeFisica"
                label="Pratica atividade física"
                color="primary"
                density="compact"
                hide-details
                class="mr-4"
              />
              <v-text-field
                v-model="form.obsEstiloAtividadeFisica"
                variant="outlined"
                label="Observação sobre atividade física"
                :disabled="!form.estiloAtividadeFisica"
                density="compact"
                hide-details
                class="flex-grow-1"
              />
            </div>
          </div>
        </v-col>
      </v-row>
      <v-divider class="my-3" />

      <!-- Section 7: Antecedentes Familiares -->
      <v-row class="mb-2">
        <v-col
          cols="12"
          class="py-0"
        >
          <h3 class="text-h6 text-primary font-weight-medium">
            Antecedentes Familiares
          </h3>
        </v-col>
        <v-col
          cols="6"
          class="pt-0"
        >
          <v-checkbox
            v-model="form.antecedentesHipertensao"
            label="Hipertensão"
            color="primary"
            density="compact"
            hide-details
          />
          <v-checkbox
            v-model="form.antecedentesDiabetes"
            label="Diabetes"
            color="primary"
            density="compact"
            hide-details
          />
        </v-col>
        <v-col
          cols="6"
          class="pt-0"
        >
          <v-checkbox
            v-model="form.antecedentesCardiopatias"
            label="Cardiopatias"
            color="primary"
            density="compact"
            hide-details
          />
          <v-checkbox
            v-model="form.antecedentesCancer"
            label="Câncer"
            color="primary"
            density="compact"
            hide-details
          />
        </v-col>
        <v-col
          cols="12"
          class="pt-0"
        >
          <v-textarea
            v-model="form.obsAntecedentesFamiliares"
            variant="outlined"
            name="obsAntecedentesFamiliares"
            label="Observação sobre antecedentes familiares"
            rows="2"
            row-height="20"
            density="compact"
            hide-details
          />
        </v-col>
      </v-row>
      <v-divider class="my-3" />

      <!-- Section 8: Exame Físico -->
      <v-row class="mb-2">
        <v-col
          cols="12"
          class="py-0"
        >
          <h3 class="text-h6 text-primary font-weight-medium">
            Exame Físico
          </h3>
        </v-col>
        <v-col
          cols="6"
          class="pt-0"
        >
          <v-text-field
            v-model="form.altura"
            variant="outlined"
            label="Altura"
            density="compact"
            hide-details
          />
          <v-text-field
            v-model="form.peso"
            variant="outlined"
            label="Peso"
            density="compact"
            hide-details
          />
          <v-text-field
            v-model="form.frequenciaCardiaca"
            variant="outlined"
            label="Frequência Cardíaca"
            density="compact"
            hide-details
          />
          <v-text-field
            v-model="form.pressaoArterial"
            variant="outlined"
            label="Pressão Arterial"
            density="compact"
            hide-details
          />
        </v-col>
        <v-col
          cols="6"
          class="pt-0"
        >
          <v-text-field
            v-model="form.abdomen"
            variant="outlined"
            label="Abdômen"
            density="compact"
            hide-details
          />
          <v-text-field
            v-model="form.temperatura"
            variant="outlined"
            label="Temperatura"
            density="compact"
            hide-details
          />
          <v-text-field
            v-model="form.frequenciaRespiratoria"
            variant="outlined"
            label="Frequência Respiratória"
            density="compact"
            hide-details
          />
        </v-col>
        <v-col
          cols="12"
          class="pt-0"
        >
          <v-checkbox
            v-model="form.exameFisicoNormal"
            label="Exame físico normal"
            color="primary"
            density="compact"
            hide-details
          />
        </v-col>
      </v-row>
      <v-divider class="my-3" />

      <!-- Section 9: Conclusão -->
      <v-row class="mb-2">
        <v-col
          cols="12"
          class="py-0"
        >
          <h3 class="text-h6 text-primary font-weight-medium">
            Conclusão
          </h3>
        </v-col>
        <v-col
          cols="12"
          class="pt-0"
        >
          <v-radio-group
            v-model="form.conclusao"
            inline
            hide-details
            density="compact"
          >
            <v-radio
              label="Apto"
              value="Apto"
              color="primary"
            />
            <v-radio
              label="Inapto"
              value="Inapto"
              color="primary"
            />
          </v-radio-group>
        </v-col>
      </v-row>

      <!-- Section 10: Recomendações -->
      <v-row class="mb-2">
        <v-col
          cols="12"
          class="py-0"
        >
          <h3 class="text-h6 text-primary font-weight-medium">
            Recomendações
          </h3>
        </v-col>
        <v-col
          cols="12"
          class="pt-0"
        >
          <v-textarea
            v-model="form.recomendacoes"
            variant="outlined"
            name="recomendacoes"
            label="Recomendações"
            rows="2"
            row-height="20"
            density="compact"
            hide-details
          />
        </v-col>
      </v-row>

      <!-- Submit button -->
      <v-card-actions class="px-0 mt-4">
        <v-spacer />
        <v-btn
          :loading="loadSave"
          variant="outlined"
          color="grey-darken-1"
          size="small"
          @click="$emit('voltar', 'voltar')"
        >
          <v-icon start>
            mdi-keyboard-return
          </v-icon>
          Cancelar
        </v-btn>
        <v-btn
          :loading="loadSave"
          color="primary"
          :disabled="!valid"
          size="small"
          @click="cadastrarFichaExamesOS"
        >
          <v-icon start>
            mdi-content-save
          </v-icon>
          Salvar
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-container>
</template>

<script>
import { ref, watch, onMounted } from 'vue'

export default {
  name: 'FichaPaciente',
  
  props: {
    idExamesOS: null
  },

  emits: ['voltar'],

  setup(props, { emit }) {
    // Refs
    const valid = ref(false)
    const load = ref(false)
    const loadSave = ref(false)

    const form = ref({
      acidente: false,
      historicoObs: '',
      acidenteObs: '',
      exameFisicoNormal: false,
      sintomalogiaObs: `
      <label for="pa">PA:</label>
      <input type="text" id="pa" name="pa" size="5">  x  
      <input type="text" id="pa2" name="pa2" size="5"> mmHg<br><br>

      <label for="freq">Frequência cardíaca:</label>
      <input type="text" id="freq" name="freq" size="5"> bp/m<br><br>

      <label for="queixas">Queixas ou achados anormais ao:</label><br>
      <textarea id="queixas" name="queixas" rows="3" cols="50"></textarea><br><br>

      <label for="audiometria">Audiometria:</label><br>
      <input type="text" id="audiometria" name="audiometria" size="50"><br><br>

      <label for="ac_visual">Ac. Visual:</label><br>
      <input type="text" id="ac_visual" name="ac_visual" size="50"><br><br>

      <label for="vacina">Vacina:</label><br>
      <input type="text" id="vacina" name="vacina" size="50">`,
      idexamesos: null,
      queixas: '',
      historicoLaboral: '',
      sofreuAcidente: null,
      acidenteAfastamento: false,
      acidenteSequelas: false,
      acidenteSemAfastamento: false,
      pressaoArterial: null,
      acidenteSemSequelas: false,
      obsAcidente: null,
      afastamentoInss: '',
      antecedentesComorbidades: false,
      antecedentesCirurgias: false,
      antecedentesAcidentes: false,
      obsAntecedentes: '',
      estiloFuma: false,
      estiloBebe: false,
      estiloAtividadeFisica: false,
      obsEstiloFuma: null,
      obsEstiloBebe: null,
      obsEstiloAtividadeFisica: null,
      antecedentesHipertensao: false,
      antecedentesCardiopatias: false,
      antecedentesDiabetes: false,
      antecedentesCancer: false,
      obsAntecedentesFamiliares: '',
      altura: '',
      peso: '',
      frequenciaCardiaca: '',
      abdomen: '',
      temperatura: '',
      frequenciaRespiratoria: '',
      conclusao: null,
      recomendacoes: ''
    })

    // Methods
    const cadastrarFichaExamesOS = async () => {
      form.value.idexamesos = props.idExamesOS
      loadSave.value = true
      try {
        console.log('Cadastrando ficha:', form.value)
        setTimeout(() => {
          emit('voltar', 'voltar')
        }, 1000)
      } finally {
        loadSave.value = false
      }
    }

    const buscarFichaExamesOS = async () => {
      load.value = true
      try {
        console.log('Buscando ficha para ID:', props.idExamesOS)
        setTimeout(() => {
          form.value = {
            ...form.value,
            queixas: 'Exemplo de queixas do paciente',
            historicoLaboral: 'Exemplo de histórico laboral',
            sofreuAcidente: 'Não'
          }
        }, 1000)
      } finally {
        load.value = false
      }
    }

    // Watchers
    watch(() => form.value.sofreuAcidente, (val) => {
      if (val !== 'Sim') {
        form.value.acidenteAfastamento = false
        form.value.acidenteSequelas = false
        form.value.acidenteSemAfastamento = false
        form.value.acidenteSemSequelas = false
        form.value.obsAcidente = null
      }
    })

    // Lifecycle
    onMounted(() => {
      buscarFichaExamesOS()
    })

    return {
      valid,
      load,
      loadSave,
      form,
      cadastrarFichaExamesOS
    }
  }
}
</script>

<style scoped>
.text-h6 {
  font-weight: 600;
  margin-bottom: 8px;
}

.v-card-actions {
  border-top: 1px solid rgba(0, 0, 0, 0.12);
}

/* Estilo para os campos compactos */
:deep(.v-field) {
  font-size: 0.875rem;
}

:deep(.v-label) {
  font-size: 0.875rem;
}

:deep(.v-messages) {
  min-height: 0;
}

/* Espaçamento reduzido entre seções */
.v-row {
  margin-bottom: 8px;
}

.v-col {
  padding-top: 4px;
  padding-bottom: 4px;
}
</style>